import React, { FC, useState } from "react";
import { Grid, Box, Typography, Button, CircularProgress } from "@material-ui/core"
import Paper from "@material-ui/core/Paper";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { RialSeparator } from "../../../utils/price-separator";
import IrancellIcon from '../../../assets/images/irancell-icon.svg';
import HamrahAvalIcon from '../../../assets/images/hamrahAvalIcon.svg';
import RightelIcon from '../../../assets/images/rightelIcon.svg';
import { billPaymentApi } from "../../../services/api/bill"
import "./style.scss";

const Transaction: FC = () => {
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false)
  const [term, setTerm] = useState<string>('mid_term')
  const history = useHistory();
  const { info } = useSelector(({ payment }: any) => payment);

  const textHelper = {
    1: {
      text: 'تلفن همراه/ ایرانسل',
      icon: IrancellIcon
    },
    2: {
      text: 'تلفن همراه/ همراه اول',
      icon: HamrahAvalIcon
    },
    3: {
      text: 'تلفن همراه/ رایتل',
      icon: RightelIcon
    },
    4: {
      text: 'تلفن ثابت'
    }
  }

  const handleTerm = (value: string) => {
    if (!loading)
      setTerm(value)
  }

  const handleSubmit = async () => {
    setLoading(true)
    const data: any = {
      mobile_number: info.line_number,
      bill_code: info[term].bill_code,
      pay_id: info[term].payment_code,
      amount: info[term].amount,
      add_to_my_bill: false
    }
    const res = await billPaymentApi(data)
    if (res)
      window.open(res.ipg_url, "_self")

    setLoading(false)
  }

  if (redirect || !info) history.push("/");

  return (
    <div className="main pt-4 mb-5">
      {/* @ts-ignore */}
      <Grid container justifyContent="center" style={{ marginTop: "45px" }}>
        <Grid item lg={4} md={6} xs={12}>
          {/* @ts-ignore */}
          <Box className="main-container pb-4">
            {/* @ts-ignore */}
            <Box display="flex" justifyContent="center">
              {
                info?.operator_id !== 4 && <img
                  // @ts-ignore
                  src={textHelper[info?.operator_id]?.icon}
                  width="80px"
                  className="img-res"
                  style={{ marginTop: "-25px" }}
                />
              }
            </Box>
            {/* @ts-ignore */}
            <Box
              display="flex"
              justifyContent="center"
              style={{ marginTop: "25px" }}
            >
              {/* @ts-ignore */}
              <Typography>قبض {textHelper[info?.operator_id].text}</Typography>
            </Box>

            <div className="container">
              <Paper className="paper text-center px-5 mt-5">
                {/* @ts-ignore */}
                <Box display="flex" justifyContent="space-between">
                  <Typography
                    className="small pt-1"
                    style={{
                      direction: "rtl",
                      fontSize: "16px",
                      fontWeight: "800",
                    }}
                  >
                    {info?.line_number}
                  </Typography>
                  {/* @ts-ignore */}
                  <Typography
                    className="small pt-1"
                    style={{
                      direction: "rtl",
                      fontSize: "16px",
                      fontWeight: "800",
                    }}
                  >
                    شماره تلفن:
                  </Typography>
                </Box>
              </Paper>
              {/* @ts-ignore */}

              <Button
                variant="contained"
                className={`${term === 'mid_term' ? 'yellow-paper-active' : 'yellow-paper'} w-100 mt-4`}
                size="large"
                onClick={() => handleTerm('mid_term')}
                disabled={!!info['mid_term'].amount ? false : true}
              >
                {/* @ts-ignore */}
                <Box display="flex" justifyContent="space-between">
                  <Typography
                    className="small"
                    style={{
                      direction: "rtl",
                      fontSize: "16px",
                      fontWeight: "800",
                    }}
                  >
                    {RialSeparator(info['mid_term'].amount)} ریال
                  </Typography>
                  {/* @ts-ignore */}
                  <Typography
                    className="small"
                    style={{
                      direction: "rtl",
                      fontSize: "16px",
                      fontWeight: "800",
                    }}
                  >
                    بدهی میان دوره:
                  </Typography>
                </Box>
              </Button>

              <Button
                variant="contained"
                className={`${term === 'final_term' ? 'yellow-paper-active' : 'yellow-paper'} w-100 mt-4`}
                size="large"
                onClick={() => handleTerm('final_term')}
                disabled={!!info['final_term'].amount ? false : true}
              >
                {/* @ts-ignore */}
                <Box display="flex" justifyContent="space-between">
                  <Typography
                    className="small"
                    style={{
                      direction: "rtl",
                      fontSize: "16px",
                      fontWeight: "800",
                    }}

                  >
                    {RialSeparator(info['final_term'].amount)} ریال
                  </Typography>
                  {/* @ts-ignore */}
                  <Typography
                    className="small"
                    style={{
                      direction: "rtl",
                      fontSize: "16px",
                      fontWeight: "800",
                    }}
                  >
                    بدهی پایان دوره:
                  </Typography>
                </Box>
              </Button>


              <Grid container spacing={2}>
                <Grid item xs={4}>
                  {/* @ts-ignore */}
                  <Box>
                    <Button
                      variant="contained"
                      className="back endBtn mt-4"
                      onClick={() => setRedirect(true)}
                    >
                      بازگشت
                    </Button>
                  </Box>
                </Grid>
                <Grid item xs={8}>
                  {/* @ts-ignore */}
                  <Box>
                    <Button
                      variant="contained"
                      className="success mt-4"
                      onClick={handleSubmit}
                      disabled={loading ? true : false}
                    >
                      {loading ? <CircularProgress color="inherit" style={{ width: '20px', height: '20px', marginBottom: '-6px' }} /> : "پرداخت"}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </div>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default Transaction;